import { selectKnownMailboxes } from './selectKnownMailboxes'

export const selectMailboxes = selectKnownMailboxes
